import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

createApp(App)
  .use(router)
  .mount('#app');

// Set up a global Axios interceptor
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});